var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-self-center speed-up"},[_c('button',{on:{"click":function($event){return _vm.toggleSpeed()}}},[(!_vm.speed)?_c('span',[_c('fa-icon',{attrs:{"icon":"fast-forward"}})],1):_c('span',[_c('fa-icon',{attrs:{"icon":"fast-backward"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }